const {fr} = require("date-fns/locale");
module.exports = Object.assign({dateFnsLocale: fr}, {
  "didomi_api_key": "2127e597-3d3f-4aa2-9727-c8126f86298c",
  "notifications_service_endpoint_development": "https://d-ksa-mad-common-euw-apim.azure-api.net/dato/send/form/instit",
  "notifications_service_endpoint_production": "https://apim.keolis.com/dato/send/form/instit/",
  "notifications_service_endpoint_quality": "https://q-ksa-mad-common-euw-apim.azure-api.net/KPI000/notification",
  "notification_service_token_development": "86656abb2f7b4375bc467c0f29dc4605",
  "notification_service_token_production": "1142321004f3407b98a95856f9820607",
  "notification_service_token_quality": "e72b93190bdb44daad825f9741ef82df",
  "piano_site_id": "639196",
  "website_name": {
    "en": "Innovation Portal",
    "fr": "Portail Innovation"
  },
  "google_tag_manager_id": "GTM-N9QM4QJ",
  "google_analytics_key": "",
  "token_google_site_verification": "0tCF4DzZT5iGAcO1bKSvlklfhHNmKxTg4do4MdxKndA",
  "updated_at": "2025-01-21T12:21:28.234+01:00",
  "created_at": "2021-09-16T11:03:11.190+02:00",
  "locale": "fr",
  "locales": [
    "fr",
    "en"
  ],
  "siteUrl": "https://innovation.keolis.com/"
})